import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSettings } from '../api';

const ThemeContext = createContext(null);

function getAutoSeason() {
  const month = new Date().getMonth() + 1;
  return (month >= 5 && month <= 9) ? 'summer' : 'winter';
}

export function ThemeProvider({ children }) {
  const [season, setSeason] = useState(getAutoSeason());
  const [settings, setSettings] = useState({});

  useEffect(() => {
    getSettings().then(s => {
      setSettings(s);
      if (s.theme_override === 'summer' || s.theme_override === 'winter') {
        setSeason(s.theme_override);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    document.body.className = `theme-${season}`;
  }, [season]);

  return (
    <ThemeContext.Provider value={{ season, settings }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
